export type Feature = {
  index: string
  title: string
  description: string
}

export type LandingConfig = {
  brand: string
  telegramUrl: string
  /** Three plain facts shown on the first screen, above the mood copy. */
  heroFacts: string[]
  /**
   * Section 02, drawn as the route a request actually takes. Every line here
   * must stay true to how the app works — see the README's privacy note.
   */
  dataFlow: Array<{ step: string; title: string; description: string }>
  features: Feature[]
  /** Shown as a spec row above the final CTA. Keep to verifiable facts. */
  accessMeta: Array<{ label: string; value: string }>
  scene: {
    desktopParticles: number
    mobileParticles: number
    maxDpr: number
  }
}

export const landingConfig: LandingConfig = {
  brand: 'Finance Tracker',
  telegramUrl: 'https://t.me/orig_finance_tracker_bot?start=invite',
  heroFacts: ['Дневной лимит', 'Свои категории', 'Ваша Google Таблица'],
  dataFlow: [
    {
      step: 'Запрос',
      title: 'Telegram Mini App',
      description:
        'Каждый запрос подписан Telegram, а доступ открыт по списку. Остальные видят экран без доступа.',
    },
    {
      step: 'Проверка',
      title: 'Сервер',
      description:
        'Проверяет подпись и знает адрес скрипта к таблице. В браузер этот адрес не передаётся.',
    },
    {
      step: 'Хранение',
      title: 'Ваша Google Таблица',
      description:
        'Операции лежат здесь. Выгрузить данные или закрыть доступ вы можете сами, не спрашивая нас.',
    },
  ],
  features: [
    {
      index: '01',
      title: 'Дневной лимит',
      description:
        'Система считает, сколько можно потратить сегодня, и пересчитывает сумму вместе с остатком месяца.',
    },
    {
      index: '02',
      title: 'Категории трат',
      description:
        'Каждая покупка ложится в свою категорию — видно, куда уходят деньги, без ручной разметки.',
    },
    {
      index: '03',
      title: 'Доходы и расходы',
      description:
        'Полная картина движения средств: поступления, списания и остаток собраны в одном месте.',
    },
    {
      index: '04',
      title: 'Ваша Google Таблица',
      description:
        'Все транзакции остаются в вашей таблице, а не в чужой базе. Выгрузить, пересчитать или забрать данные можно в любой момент.',
    },
    {
      index: '05',
      title: 'Apple Shortcuts',
      description:
        'Расход добавляется командой Apple Shortcuts — с экрана блокировки или голосом, не открывая лишних приложений.',
    },
    {
      index: '06',
      title: 'Внутри Telegram',
      description:
        'Никаких новых приложений и паролей. Учёт живёт там, где вы и так каждый день.',
    },
  ],
  accessMeta: [
    { label: 'Формат', value: 'Telegram Mini App' },
    { label: 'Доступ', value: 'По заявке' },
  ],
  scene: {
    desktopParticles: 1450,
    mobileParticles: 620,
    maxDpr: 1.6,
  },
}
